export default "/assets/images/real-time-air-alert-thumbnail.jpg?05f210b5fd58a4f94e27f992125ec2e5";